// Libraries
import React from 'react';
// Components
import { BreadCrumb, PaymentPageTab } from '../../components';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { last } from 'lodash';

// Actions
import {
    getPaymentPageDetailsRequest,    
} from '../PaymentPage/redux/paymentPage.actions';


const EditPaymentPage = ({
    actions,
    paymentPageEditData,
    paymentPageData,
}) => {
    console.log("paymentPageData",paymentPageData);
    const {formId } = useParams();
    console.log("form id : ", formId);
    const req ={
        "formId":formId
    }
    useEffect(()=>{
        actions.getPaymentPageDetailsRequest(req);
    },[actions]);

    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3> Create Payment Page </h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Payment Page',
                            link: '/payment-page',
                        },
                        {
                            name: 'Create Payment Page',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <PaymentPageTab 
                    initialValues= {paymentPageData} 
                />
            </div>
        </div>
    );
};
const mapStateToProps = ({ loader }) => ({
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            getPaymentPageDetailsRequest
        },
        dispatch
    ),
});
EditPaymentPage.propTypes = {
    actions: PropTypes.object,
    editData: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentPage);

